// Librairies
import { v4 as uuidv4 } from 'uuid';
import { addDays } from 'date-fns';
import i18n from '../locales/i18n';
// Utils
import DatesUtil from './DatesUtil';
import TreesUtil from './TreesUtil';
import { faCheck, faEdit, faPlus, faQuestion, faTimes, faTrash } from '@fortawesome/pro-solid-svg-icons';
import GreenSpacesUtil from './GreenSpacesUtil';

export default class ActionsUtil {
    static createOfflineRecurrences(projectAction) {
        let paerList = [];
        const startDate = DatesUtil.convertUTCDateToDate(projectAction.startDate);
        const endDate = DatesUtil.convertUTCDateToDate(projectAction.endDate);
        const recurrenceSplit = projectAction.recurrence.split(' - ');
        const recurrenceValue = parseInt(recurrenceSplit[0]);
        const recurrenceUnit = recurrenceSplit[1];
        let tempDate = startDate;

        switch (recurrenceUnit) {
            case 'Jours':
                while (tempDate <= endDate) {
                    paerList.push({ id: uuidv4(), date: tempDate, comment: '', status: null });
                    tempDate = new Date(tempDate.getFullYear(), tempDate.getMonth(), tempDate.getDate() + recurrenceValue, tempDate.getHours(), tempDate.getMinutes(), tempDate.getSeconds(), tempDate.getMilliseconds());
                }
                break;
            case 'Semaines':
                while (tempDate <= endDate) {
                    paerList.push({ id: uuidv4(), date: tempDate, comment: '', status: null });
                    tempDate = new Date(tempDate.getFullYear(), tempDate.getMonth(), tempDate.getDate() + recurrenceValue * 7, tempDate.getHours(), tempDate.getMinutes(), tempDate.getSeconds(), tempDate.getMilliseconds());
                }
                break;
            case 'Mois':
                while (tempDate <= endDate) {
                    paerList.push({ id: uuidv4(), date: tempDate, comment: '', status: null });
                    tempDate = new Date(tempDate.getFullYear(), tempDate.getMonth() + recurrenceValue, tempDate.getDate(), tempDate.getHours(), tempDate.getMinutes(), tempDate.getSeconds(), tempDate.getMilliseconds());
                }
                break;
            case 'Années':
                while (tempDate <= endDate) {
                    paerList.push({ id: uuidv4(), date: tempDate, comment: '', status: null });
                    tempDate = new Date(tempDate.getFullYear() + recurrenceValue, tempDate.getMonth(), tempDate.getDate(), tempDate.getHours(), tempDate.getMinutes(), tempDate.getSeconds(), tempDate.getMilliseconds());
                }
                break;
            default: break;
        }

        return paerList;
    }

    static getRecurrencesInfos(projectAction) {
        const startDate = DatesUtil.convertUTCDateToDate(projectAction.startDate);
        const endDate = projectAction.endDate ? DatesUtil.convertUTCDateToDate(projectAction.endDate) : null;
        if (!projectAction.recurrence) return i18n.t("Aucune");
        const recurrenceSplit = projectAction.recurrence.split(' - ');
        const recurrenceValue = parseInt(recurrenceSplit[0]);
        const recurrenceUnit = recurrenceSplit[1];
        let recurrenceString; let nbRecurrences = 0;
        let tempDate = startDate;

        switch (recurrenceUnit) {
            case 'Jours':
                if (recurrenceValue === 1) recurrenceString = i18n.t("Tous les jours");
                else recurrenceString = i18n.t("Tous les {{recurrence}} jours", { recurrence: recurrenceValue });
                // Calcul du nombre de récurrences totales dans le temps
                if (endDate)
                    while (tempDate <= endDate) {
                        nbRecurrences++;
                        tempDate.setDate(tempDate.getDate() + recurrenceValue);
                    }
                break;
            case 'Semaines':
                if (recurrenceValue === 1) recurrenceString = i18n.t("Toutes les semaines");
                else recurrenceString = i18n.t("Tous les {{recurrence}} semaines", { recurrence: recurrenceValue });
                // Calcul du nombre de récurrences totales dans le temps
                if (endDate)
                    while (tempDate <= endDate) {
                        nbRecurrences++;
                        tempDate.setDate(tempDate.getDate() + recurrenceValue * 7);
                    }
                break;
            case 'Mois':
                if (recurrenceValue === 1) recurrenceString = i18n.t("Tous les mois");
                else recurrenceString = i18n.t("Tous les {{recurrence}} mois", { recurrence: recurrenceValue });
                // Calcul du nombre de récurrences totales dans le temps
                if (endDate)
                    while (tempDate <= endDate) {
                        nbRecurrences++;
                        tempDate = DatesUtil.addMonths(tempDate, recurrenceValue);
                    }
                break;
            case 'Années':
                if (recurrenceValue === 1) recurrenceString = i18n.t("Tous les ans");
                else recurrenceString = i18n.t("Tous les {{recurrence}} ans", { recurrence: recurrenceValue });
                // Calcul du nombre de récurrences totales dans le temps
                if (endDate)
                    while (tempDate <= endDate) {
                        nbRecurrences++;
                        tempDate.setFullYear(tempDate.getFullYear() + recurrenceValue);
                    }
                break;
            default: break;
        }

        return recurrenceString + (nbRecurrences ? ' (' + nbRecurrences + 'x)' : '');
    }

    static getCurrentRecurrenceIndex(projectActionElementRecurrences) {
        let currentRecurrenceIndex = 0, recurrences;
        const today = DatesUtil.getToday();

        // Récurrence en retard, en cours ou à venir non validée (max 7 jours en avance)
        recurrences = projectActionElementRecurrences.filter(x => DatesUtil.daysBetweenTwoDates(DatesUtil.convertUTCDateToDate(x.date), today) < 7);
        if (recurrences) {
            currentRecurrenceIndex = recurrences.findIndex(x => x.status && DatesUtil.daysBetweenTwoDates(DatesUtil.convertUTCDateToDate(x.date), today) < 0); // En retard
            if (currentRecurrenceIndex === -1) currentRecurrenceIndex = recurrences.findIndex(x => !x.status && DatesUtil.daysBetweenTwoDates(DatesUtil.convertUTCDateToDate(x.date), today) >= 0); // A venir
            if (currentRecurrenceIndex === -1) { // Dernière validée
                const recurrence = recurrences.reverse().find(x => x.status === 'done');
                currentRecurrenceIndex = projectActionElementRecurrences.findIndex(x => x === recurrence);
            }
        }

        return currentRecurrenceIndex > -1 ? currentRecurrenceIndex : 0;
    }

    static isRecurrenceBetweenTwoDates(paer, date1, date2) {
        date1 = date1 ? new Date(date1) : null;
        date2 = date2 ? new Date(date2) : null;
        if (!date1 && !date2) return true;
        else {
            let res;
            const paerDate = DatesUtil.convertUTCDateToDate(paer.date);
            if (date1 && date2) {
                const res1 = DatesUtil.daysBetweenTwoDates(paerDate, date1);
                const res2 = DatesUtil.daysBetweenTwoDates(paerDate, date2);
                return res1 >= 0 && res2 <= 0;
            } else if (date1) {
                res = DatesUtil.daysBetweenTwoDates(paerDate, date1);
                return res >= 0;
            } else if (date2) {
                res = DatesUtil.daysBetweenTwoDates(paerDate, date2);
                return res <= 0;
            } else return true;
        }
    }

    static getRecurrencePrice(recurrence, action, feature, priceList = null) {
        if (recurrence?.status === 'cancelled') return 0;
        if (recurrence?.customPrice) return Number(recurrence.customPrice);
        return ActionsUtil.getActionPrice(action, feature, priceList);
    }

    static getActionPrice(action, feature, priceList = null) {
        const customPrice = priceList?.prices?.find(price => price.actionId === action.id);
        const property = customPrice ? customPrice.property : action.defaultProperty;
        const thresholds = priceList?.priceThresholds?.find(threshold => threshold.property === property)?.values;

        if (!feature?.properties) return 0;
        switch (feature.properties.category) {
            case 'Arbre':
                const biggestTrunk = TreesUtil.getBiggestTrunkOf(feature.properties);
                if (!customPrice) {
                    if (!action.defaultProperty) return action.price1;
                    const height = biggestTrunk ? biggestTrunk.height / 100 : 0;
                    const isStumpOrChronoxyle = feature?.properties.isStump || feature?.properties.isChronoxyle;
                    const stumpDiameter = isStumpOrChronoxyle && TreesUtil.getStumpDiameterByCircumference(biggestTrunk ? biggestTrunk.circumference : 0);
                    if (isStumpOrChronoxyle ? stumpDiameter?.id === 1 : (height >= 0 && height <= 5)) return action.price1;
                    if (isStumpOrChronoxyle ? stumpDiameter?.id === 2 : (height > 5 && height <= 10)) return action.price2;
                    if (isStumpOrChronoxyle ? stumpDiameter?.id === 3 : (height > 10 && height <= 15)) return action.price3;
                    if (isStumpOrChronoxyle ? stumpDiameter?.id === 4 : (height > 15 && height <= 20)) return action.price4;
                    if (isStumpOrChronoxyle ? stumpDiameter?.id === 5 : (height > 20 && height <= 25)) return action.price5;
                    if (isStumpOrChronoxyle ? stumpDiameter?.id === 6 : height > 25) return action.price6;
                    return 0;
                }

                if (property && thresholds?.length) {
                    let value = biggestTrunk ? biggestTrunk[property] : 0;
                    if (['height', 'crownDiameter'].includes(property)) value /= 100;
                    for (let i = 0; i < thresholds.length; i++)
                        if (value <= thresholds[i]) return customPrice.values?.[i] || 0;
                    return customPrice.values?.at(-1) || 0;
                } else return customPrice.values?.[0] || 0;
            case 'Espace vert':
                if (feature.properties.dominantCompositionId === 7 && action.categories.includes('Arbre')) { // Massifs arborés
                    const woodedArea = GreenSpacesUtil.getMainWoodedArea(feature.properties.woodedAreas);
                    if (!woodedArea) return 0;

                    if (!customPrice) {
                        if (!action.defaultProperty) return action.price1 * woodedArea.nbTrees;
                        const height = woodedArea ? woodedArea.averageHeight / 100 : 0;
                        if (height >= 0 && height <= 5) return action.price1 * woodedArea.nbTrees;
                        if (height > 5 && height <= 10) return action.price2 * woodedArea.nbTrees;
                        if (height > 10 && height <= 15) return action.price3 * woodedArea.nbTrees;
                        if (height > 15 && height <= 20) return action.price4 * woodedArea.nbTrees;
                        if (height > 20 && height <= 25) return action.price5 * woodedArea.nbTrees;
                        if (height > 25) return action.price6 * woodedArea.nbTrees;
                        return 0;
                    }

                    if (property && thresholds?.length) {
                        const properties = { height: 'averageHeight', circumference: 'averageCircumference', crownDiameter: 'averageCrownDiameter' };
                        let value = woodedArea ? woodedArea[properties[property]] : 0;
                        if (['averageHeight', 'averageCrownDiameter'].includes(property)) value /= 100;
                        for (let i = 0; i < thresholds.length; i++)
                            if (value <= thresholds[i]) return (customPrice.values?.[i] || 0) * woodedArea.nbTrees;
                        return (customPrice.values?.at(-1) || 0) * woodedArea.nbTrees;
                    } else return (customPrice.values?.[0] || 0) * woodedArea.nbTrees;
                } else {
                    if (!customPrice) {
                        if (!action.defaultProperty) return action.price1;
                        return feature.properties.surface * action.price1;
                    }

                    const value = property === 'length'
                        ? feature.properties.baseLine?.length
                        : property === 'perimeter'
                            ? feature.properties.perimeter
                            : feature.properties.surface;
                    if (property && thresholds?.length) {
                        for (let i = 0; i < thresholds.length; i++)
                            if (value <= thresholds[i]) return (customPrice.values?.[i] || 0) * value;
                        return (customPrice.values?.at(-1) || 0) * value;
                    } else return (customPrice.values?.[0] || 0) * (property ? value : 1);
                }
            case 'Mobilier':
                if (!customPrice) return action.price1;
                else return customPrice.values?.[0] || 0;
            default: return 0;
        }
    }

    static pushProjectActionElements(projectAction, projectActions, override = false) {
        projectActions = JSON.parse(JSON.stringify(projectActions));
        let pa = projectActions.find(x => x.id === projectAction.id);
        if (pa && !override) {
            projectAction.projectActionElements.forEach(pae => {
                const index = pa.projectActionElements.findIndex(x => x.elementId === pae.elementId);
                if (index === -1) pa.projectActionElements.push(pae);
                else if (pae.projectActionElementRecurrences) pa.projectActionElements[index] = pae;
            });
        } else if (pa && override) pa.projectActionElements = projectAction.projectActionElements;
        else projectActions.push(projectAction);
        return projectActions;
    }

    // Niveaux (le plus prioritaire l'emporte) : 5 en retard, 4 à venir -1 mois, 3 à venir +1 mois, 2 validée, 1 annulée, 0 pas d'action
    static getActionUrgency(actionsUrgency, projectAction, projectActionElementRecurrences) {
        if (actionsUrgency < 5 && projectActionElementRecurrences.find(paer => !paer.status && DatesUtil.convertUTCDateToDate(paer.date) < DatesUtil.getToday()))
            return 5;
        if (actionsUrgency < 4 && projectActionElementRecurrences.find(paer => !paer.status && DatesUtil.convertUTCDateToDate(paer.date) < addDays(DatesUtil.getToday(), 30)))
            return 4;
        if (actionsUrgency < 3 && projectActionElementRecurrences.find(paer => !paer.status && DatesUtil.convertUTCDateToDate(paer.date) >= DatesUtil.getToday()))
            return 3;
        if (actionsUrgency < 2 && projectActionElementRecurrences.find(paer => paer.status === 'done'))
            return 2;
        if (actionsUrgency < 1 && projectActionElementRecurrences.find(paer => paer.status === 'cancelled'))
            return 1;
        return actionsUrgency;
    }

    static getElementActionsUrgency(elementId, projectActions, category) {
        let actionsUrgency = 0;
        projectActions.filter(pa => pa.action.categories.includes(category)).forEach(pa => { // Pour chacune des actions du projet
            const pae = pa.projectActionElements.find(pae => pae.elementId === elementId);
            if (pae) actionsUrgency = ActionsUtil.getActionUrgency(actionsUrgency, pa, pae.projectActionElementRecurrences);
        });
        return actionsUrgency;
    }

    static getActionHistoryIcon(type) {
        return {
            action_linked: faPlus,
            action_unlinked: faTrash,
            recurrence_validation: faCheck,
            recurrence_invalidation: faTimes,
            validation_date_update: faEdit,
            comment_addition: faPlus,
            comment_update: faEdit
        }[type] || faQuestion;
    }
}